"use strict";

angular.module("imagetrend.components").directive("hlpSelect", [
    "$rootScope",
    "$templateCache",
    "Validation",
    "$timeout",
    "$q",
    "DataElements",
    function ($rootScope, $templateCache, Validation, $timeout, $q, DataElements) {
        // if you supply your options array objects with an is_default property (there may only be one of these set to true, but every option must have the property)
        // then a default option will be selected. you either pass this in on the options attribute or you can include it in the call to the service you grab your options from
        // edit: also you need to set the useDefault attribute...This may have been a bad idea after all, should have just set a default in the specific controller
        var directiveScope = angular.extend({}, $rootScope.formFieldScope, {
            ngModel: "=?",
            question: "=?",
            showValue: "=?",
            ngChange: "&?",
            clear: "&?",
            validation: "=?",
            options: "=?",
            parameters: "=?",
            pdf: "=?",
            useDefault: "@?",
            autoComplete: "@?"
        });
        return {
            scope: directiveScope,
            require: "ngModel",
            transclude: true,
            template: function () {
                return $templateCache.get("templates/select/select.html");
            },
            controller: [
                "$scope",
                "$timeout",
                function ($scope, $timeout) {
                    if ($scope.question && $scope.question.parameters && $scope.question.parameters.limit_vehicle_type_ids !== null && $scope.name === 'Vehicle Type') {
                        $scope.method = "getVehiclesTypesWithTypeRestriction";
                        $scope.service = "Vehicles"
                    }

                    $scope.validate = function () {
                        if ($scope.innerForm !== undefined) {
                            if ($scope.validation) {
                                Validation.validateQuestion(
                                    $scope.innerForm[$scope.name],
                                    $scope.validation,
                                    $scope.ngModel
                                ).then(function (result) {
                                    if (
                                        $scope.question !== undefined &&
                                        $scope.question.answer !== undefined
                                    ) {
                                        $scope.question.answer.invalid =
                                            !result ||
                                            !isEmpty(
                                                $scope.innerForm[$scope.name]
                                                    .$error
                                            ) ||
                                            !isEmpty($scope.innerForm.$error);
                                    }
                                });
                            } else {
                                if (
                                    $scope.question !== undefined &&
                                    $scope.question.answer !== undefined
                                ) {
                                    $scope.question.answer.invalid = !isEmpty(
                                        $scope.innerForm[$scope.name].$error
                                    );
                                }
                            }
                        }
                    };

                    var validationTimeout = $timeout(function () {
                        if ($scope.innerForm !== undefined) {
                            if ($scope.isRequired) {
                                if (
                                    $scope.ngModel == null ||
                                    $scope.ngModel.length == 0
                                ) {
                                    $scope.innerForm[$scope.name].$setValidity(
                                        "required",
                                        false
                                    );
                                } else {
                                    $scope.innerForm[$scope.name].$setValidity(
                                        "required",
                                        true
                                    );
                                }
                            }
                            $scope.validate();
                        }
                    }, 0);

                    $scope.$on("$destroy", function () {
                        $timeout.cancel(validationTimeout);
                    });
                }
            ],
            compile: function (elem, attrs) {
                return {
                    pre: function (scope, elem, attrs, ngModel) {
                        scope.directiveAttributes = attrs;
                        scope.vm = {
                            value: null
                        };

                        if (scope.directiveAttributes.multiSelect) {
                            scope.multiSelect = true;
                        }
                        if (!scope.directiveAttributes.selectShow) {
                            scope.selectShow = "name";
                        }
                        if (!scope.directiveAttributes.selectValue) {
                            scope.selectValue = "id";
                        }
                        if (!scope.directiveAttributes.useDefault) {
                            scope.directiveAttributes.useDefault = false;
                        } else {
                            scope.directiveAttributes.useDefault = true;
                        } // javascripty

                        if (scope.selectValue == "OBJECT") {
                            if (!scope.groupBy) {
                                scope.optionClause =
                                    "getDescendantProp(opt,selectShow) for opt in dirOptions";
                            } else {
                                scope.optionClause =
                                    "getDescendantProp(opt,selectShow) group by getDescendantProp(opt,groupBy) for opt in dirOptions";
                            }
                        } else {
                            if (!scope.groupBy) {
                                scope.optionClause =
                                    "getDescendantProp(opt,selectShow) disable when opt.disable for opt in dirOptions track by getDescendantProp(opt,selectValue)";
                            } else {
                                scope.optionClause =
                                    "getDescendantProp(opt,selectShow) group by getDescendantProp(opt,groupBy) for opt in dirOptions track by getDescendantProp(opt,selectValue)";
                            }
                        }
                    },
                    post: function (scope, elem, attrs, ngModel) {
                        scope.timeouts = [];
                        scope.existingOptionsLoaded = false;
                        scope.selectedArray = [];
                        scope.autoComplete = attrs.autoComplete;

                        scope.setShowValue = function () {
                            if (scope.vm.value != null) {
                                var val = scope.getDescendantProp(
                                    scope.vm.value,
                                    scope.selectValue
                                );
                                scope.dirOptions.forEach(function (opt) {
                                    if (
                                        val ==
                                        scope.getDescendantProp(
                                            opt,
                                            scope.selectValue
                                        )
                                    ) {
                                        scope.showValue = scope.getDescendantProp(
                                            opt,
                                            scope.selectShow
                                        );
                                    }
                                });
                            }
                        };

                        var needToChangeToString = false;

                        scope.$watch("optionsLoaded", function (optionsLoaded) {
                            if (optionsLoaded && needToChangeToString && angular.isString(ngModel.$modelValue)) {
                                //Options have loaded, need to match ids to corresponding name/id pair
                                var newArray = [];
                                if (scope.dirOptions != null && angular.isArray(scope.dirOptions)) {
                                    ngModel.$modelValue.split(',').forEach(function (item) {
                                        scope.dirOptions.forEach(function (element) {
                                            if (element.id.toString().toLowerCase() == item.toLowerCase()) {
                                                newArray.push(element);
                                            }
                                        })
                                    });
                                    scope.showValue = generateStringFromArrays(
                                        newArray,
                                        scope.dirOptions
                                    );
                                    scope.selectedArray = newArray;
                                    scope.existingOptionsLoaded = true;
                                }
                            }
                            else if (optionsLoaded && scope.showValue == null) {
                                // see if there is a default option in this list of options
                                // slightly hacky conditional...if this array does not use the is_default property lets just skip this part,
                                // we assume if we do use it, every option has that property, so code accordingly
                                // ...and we have to use a for loop because ie doesn't support a few nice array methods
                                if (
                                    scope.useDefault &&
                                    scope.options &&
                                    scope.options.length > 0 &&
                                    scope.options[0].hasOwnProperty(
                                        "is_default"
                                    )
                                ) {
                                    for (
                                        var i = 0;
                                        i < scope.options.length;
                                        i++
                                    ) {
                                        if (scope.options[i].is_default) {
                                            scope.ngModel = scope.options[i].id;
                                            break;
                                        }
                                    }
                                }

                                if (scope.multiple || scope.multiSelect) {
                                    scope.showValue = generateStringFromArrays(
                                        scope.array,
                                        scope.dirOptions
                                    );
                                } else {
                                    scope.setShowValue();
                                }
                            }
                        });

                        ngModel.$render = function () {
                            if (ngModel.$modelValue != null) {
                                if (scope.multiple && !scope.multiSelect) {
                                    if (scope.method != null && scope.method != "" && scope.service != null && scope.service != "") {
                                        //If the options are already loaded we can match the ids to the corresponding name/id pair right away.
                                        if (scope.optionsLoaded) {
                                            // convert array of id's to array of objects with id and name
                                            scope.array = [];
                                            if (scope.dirOptions != null && angular.isArray(scope.dirOptions)) {
                                                if (typeof ngModel.$modelValue == "string") {
                                                    ngModel.$modelValue.split(',').forEach(function (item) {
                                                        scope.dirOptions.forEach(function (element) {
                                                            if (element.id.toString().toLowerCase() == item.toLowerCase()) {
                                                                scope.array.push(element);
                                                            }
                                                        })
                                                    });
                                                }
                                                scope.showValue = generateStringFromArrays(
                                                    scope.array,
                                                    scope.dirOptions
                                                );
                                                scope.selectedArray = scope.array;
                                                scope.existingOptionsLoaded = true;
                                            }
                                        }
                                        else {
                                            needToChangeToString = true;
                                        }
                                    }
                                    else {
                                        scope.array = [];
                                        if (typeof ngModel.$modelValue == "string") {
                                            ngModel.$modelValue.split(",").forEach(function (option) {
                                                scope.array.push({
                                                    id: option.trim(),
                                                    name: option.trim()
                                                });
                                            });
                                        }
                                        scope.showValue = generateStringFromArrays(
                                            scope.array,
                                            scope.dirOptions
                                        );
                                    }
                                } else if (scope.multiple && scope.multiSelect) {
                                    if (scope.id == "serviceClassification") {
                                        DataElements.getServiceClassification({}).then(function (classifications) {
                                            scope.dirOptions = classifications;
                                            scope.array = [];
                                            if (typeof ngModel.$modelValue == "string") {
                                                ngModel.$modelValue.split(",").forEach(function (option) {
                                                    if (getNameFromListArray(scope.dirOptions, option.trim()) != null) {
                                                        scope.array.push({
                                                            id: option.trim(),
                                                            name: getNameFromListArray(scope.dirOptions, option.trim())
                                                        });
                                                    }
                                                });
                                            }
                                            scope.showValue = generateStringFromArrays(
                                                scope.array,
                                                scope.dirOptions
                                            );

                                        })
                                    } else {
                                            scope.array = [];
                                            if (typeof ngModel.$modelValue == "string") {
                                                ngModel.$modelValue.split(",").forEach(function (option) {
                                                    if (getNameFromListArray(scope.dirOptions, option.trim()) != null) {
                                                        scope.array.push({
                                                            id: option.trim(),
                                                            name: getNameFromListArray(scope.dirOptions, option.trim())
                                                        });
                                                    }
                                                });
                                            }
                                            scope.showValue = generateStringFromArrays(
                                                scope.array,
                                                scope.dirOptions
                                            );
                                    }


                                } else {
                                    if (scope.selectValue == "OBJECT") {
                                        scope.vm.value = ngModel.$modelValue;
                                        scope.showValue = scope.getDescendantProp(
                                            scope.vm.value,
                                            scope.selectShow
                                        );
                                    } else {
                                        scope.vm.value = {};
                                        scope.vm.value[scope.selectValue] =
                                            ngModel.$modelValue;
                                        if (
                                            scope.showValue == null &&
                                            scope.optionsLoaded
                                        ) {
                                            scope.setShowValue();
                                        }
                                    }
                                }
                                if (scope.validation) {
                                    Validation.validateQuestion(
                                        scope.innerForm[scope.name],
                                        scope.validation,
                                        ngModel.$modelValue
                                    );
                                }
                            } else {
                                scope.vm.value = null;
                                scope.showValue = null;
                            }
                        };

                        scope.onChange = function (value) {
                            scope.submitted = false;
                            scope.timeouts.push(
                                $timeout(function () {
                                    if (
                                        (scope.multiple || scope.multiSelect) &&
                                        value !== undefined &&
                                        value != null
                                    ) {
                                        scope.valueArray = [];
                                        value.forEach(function (option) {
                                            if (scope.selectValue == "OBJECT") {
                                                scope.valueArray.push(
                                                    ngModel.$setViewValue(
                                                        option
                                                    )
                                                );
                                            } else {
                                                scope.valueArray.push(
                                                    scope.getDescendantProp(
                                                        option,
                                                        scope.selectValue
                                                    )
                                                );
                                            }
                                        });
                                        ngModel.$setViewValue(
                                            scope.valueArray.toString()
                                        );

                                        scope.showValue = generateStringFromArrays(
                                            ngModel.$modelValue,
                                            scope.dirOptions
                                        );
                                    } else {
                                        if (scope.selectValue == "OBJECT") {
                                            ngModel.$setViewValue(value);
                                            scope.showValue = scope.getDescendantProp(
                                                value,
                                                scope.selectShow
                                            );
                                        } else {
                                            ngModel.$setViewValue(
                                                scope.getDescendantProp(
                                                    value,
                                                    scope.selectValue
                                                )
                                            );
                                            scope.showValue = scope.getDescendantProp(
                                                value,
                                                scope.selectShow
                                            );
                                        }
                                    }

                                    if (scope.validation) {
                                        Validation.validateQuestion(
                                            scope.innerForm[scope.name],
                                            scope.validation,
                                            ngModel.$modelValue
                                        );
                                    }
                                    if (
                                        scope.question !== undefined &&
                                        scope.question.answer !== undefined
                                    ) {
                                        scope.question.answer.invalid = !isEmpty(
                                            scope.innerForm[scope.name].$error
                                        );
                                    }
                                }, 0)
                            );
                        };

                        scope.submitted = false;
                        scope.$on("form:submit", function () {
                            scope.validate();
                            scope.submitted = true;
                        });

                        scope.$on("$destroy", function () {
                            scope.timeouts.forEach(function (timer) {
                                $timeout.cancel(timer);
                            });
                        });
                    }
                };
            }
        };
    }
]);
